import React, { Component } from "react";
import clsx from "clsx";

class ToolsCheckbox extends Component {
	render() {
		const { checked, onChange, label, disabled, size = "compact", containerClass } = this.props;

		return (
			<label className={clsx("tk-checkbox", size === "form" && "tk-checkbox--form", containerClass)}>
				<input type="checkbox" checked={!!checked} disabled={!!disabled} onChange={onChange} />
				{label}
			</label>
		);
	}
}

export default ToolsCheckbox;
